<template>
    <div id="main-members-form">
        <div class="card-item">
            <div class="card-title">
                <p v-for="(item,index) in tabList" :key="index" @click="tabToggle(index)" :class="{active:index === sel}">{{item}}</p>
            </div>
            <div class="card-content">
                <basicInformationPersonnel v-if="sel == 0" />
                <qualificationInformationPersonnel v-if="sel == 1" />
                <rewardsInformationPersonnel v-if="sel == 2" />
            </div>
        </div>
    </div>
</template>

<script>
    import basicInformationPersonnel from './main-members-child/basic-information-personnel.vue'
    import qualificationInformationPersonnel from './main-members-child/qualification-information-personnel.vue'
    import rewardsInformationPersonnel from './main-members-child/rewards-information-personnel.vue'
    export default {
        name: "main-members-form",
        components:{
            basicInformationPersonnel,
            qualificationInformationPersonnel,
            rewardsInformationPersonnel
        },
        data() {
            return {
                tabList: ['人员基本信息', '人员资格信息', '人员奖罚信息'],
                sel: 0
            }
        },
        methods: {
            tabToggle (index) {
                this.sel = index;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #main-members-form{
        .card-item{
            .card-title{
                cursor: pointer;
                display: flex;
                align-items: center;
                p{
                    font-size: 16px;
                    margin: 0 32px;
                }
                .active{
                    color: #1890FF;
                    border-bottom: 2px solid #1890FF;
                    margin-bottom: 2px;
                }
            }
        }
        .bottom-btn {
            display: flex;
            justify-content: center;

            .el-button {
                width: 96px;
                height: 40px;
                margin: 20px 24px 20px 0;
            }
        }
    }
</style>